import React, { Component } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import {
  profile,
  format_date,
  GET,
  POST,
  alert,
  loading,
  Status,
  DateRangePicker,
  Pagination,
  Navbar,
  Select,
  Modal,
} from "../../components/CustomComponent.js";

const PAGE_SIZE = 30;
const AUTO_REFRESH_MS = 30000;
const SLOW_WARN_MS = 1000;
const SLOW_DANGER_MS = 3000;
const COPIED_RESET_MS = 2000;
const BROKER_USER_TYPES = ["broker", "sub_broker", "admin_broker"];

const TAB_TYPES = [
  { key: "deposit", label: "Deposit" },
  { key: "withdrawals", label: "Withdrawals" },
];
const DEFAULT_CURRENCY = "THB";
const DEFAULT_TYPE = "deposit";

const RESULT_OPTIONS = [
  { value: "", label: "--Select Result--" },
  { value: "success", label: "Success" },
  { value: "failed", label: "Failed" },
  { value: "no_response", label: "No response" },
];

const CHILLPAY_PAYMENT_STATUS_HELP = [
  "0: Success: ทำรายการชำระเงินสำเร็จ",
  "1: Fail: ทำรายการชำระเงินไม่สำเร็จ",
  "2: Cancel: ลูกค้ายกเลิกการชำระเงิน",
  "3: Error: เกิดข้อผิดพลาดระหว่างทำรายการชำระเงิน",
  "4: Request: รอการชำระค่าสินค้า/บริการ",
];

const today = () => format_date(new Date(), "yyyy-mm-dd", "en");
const toDateParam = (d) => (d ? format_date(d, "yyyy-mm-dd", "en") : "");
// backend บังคับช่วงวันที่เสมอ (ตารางหลายล้านแถว ค้นทั้งตารางไม่ไหว) ต้องตรงกับ LOG_RANGE_LIMITS ฝั่ง backend
// clear วันที่แล้วกดค้น จะถอยเป็น DEFAULT_RANGE_DAYS วันล่าสุดแทนการส่งค่าว่าง
const DEFAULT_RANGE_DAYS = 7;
const MAX_RANGE_DAYS = 31;
const daysAgo = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return format_date(d, "yyyy-mm-dd", "en");
};

const isSuccessStatus = (code) => Number(code) >= 200 && Number(code) < 300;
const isFailedDelivery = (code) =>
  code === null || code === undefined || !isSuccessStatus(code);

const responseStatusBadge = (code) => {
  if (code === null || code === undefined || code === "") {
    return Status("No response", "secondary");
  }
  const n = Number(code);
  if (n >= 200 && n < 300) return Status(code, "success");
  if (n >= 400 && n < 500) return Status(code, "warning");
  if (n >= 500) return Status(code, "danger");
  return Status(code, "secondary");
};

const eventTypeBadge = (type) => {
  const base = (type || "").split(".")[0];
  return Status(
    type || "-",
    { deposit: "success", withdrawals: "warning" }[base] || "secondary"
  );
};

const deliveryStatusBadge = (status) =>
  Status(
    status || "-",
    {
      success: "success",
      cancel: "danger",
      fail: "danger",
      failed: "danger",
      pending: "warning",
      mismatch: "warning",
      refund: "info",
    }[status] || "secondary"
  );

const methodBadge = (method) =>
  Status(
    method,
    { GET: "success", POST: "warning", PUT: "primary", DELETE: "danger" }[
      method
    ] || "secondary"
  );

const responseTimeClass = (ms) => {
  const value = Number(ms) || 0;
  if (value >= SLOW_DANGER_MS) return "danger";
  if (value >= SLOW_WARN_MS) return "warn";
  return "";
};

const safeJSON = (v) => {
  try {
    if (v === null || v === undefined || v === "") return "";
    const obj = typeof v === "string" ? JSON.parse(v) : v;
    return JSON.stringify(obj, null, 2);
  } catch {
    return String(v);
  }
};

const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const el = document.createElement("textarea");
    el.value = text;
    el.style.position = "fixed";
    el.style.opacity = "0";
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
  }
};

// แถว response จากธนาคารขึ้นก่อนเสมอ ตามด้วยครั้งที่ส่งไป broker เรียงตามเวลา
const sortDetailRows = (rows = []) =>
  [...rows].sort((a, b) => {
    const aBank = a.response_body_bank ? 0 : 1;
    const bBank = b.response_body_bank ? 0 : 1;
    if (aBank !== bBank) return aBank - bBank;
    return new Date(a.created_at) - new Date(b.created_at);
  });

export default class Webhooks extends Component {
  constructor(props) {
    super(props);
    this.isBrokerUser = BROKER_USER_TYPES.includes(profile?.user_type);
    this.state = {
      filter_search: "",
      filter_type: DEFAULT_TYPE,
      filter_result: "",
      filter_start_date: today(),
      filter_end_date: today(),
      filter_broker_id: "",
      filter_currency: DEFAULT_CURRENCY,

      auto_refresh: false,

      page: 1,
      data: [],
      data_broker: [],
      loaded: false,
      count: 0,

      modal_detail: false,
      data_detail: [],
      expand_id: -1,
      copied_key: "",

      hover_info_index: false,
      inline_help_popup: null,
    };
    this.refreshTimer = null;
    this.copiedTimer = null;
  }

  async componentDidMount() {
    loading(false);
    await Promise.all([
      this.isBrokerUser ? Promise.resolve() : this.GetBrokers(),
      this.Get(1),
    ]);
  }

  componentWillUnmount() {
    this.stopAutoRefresh();
    if (this.copiedTimer) clearTimeout(this.copiedTimer);
  }

  startAutoRefresh = () => {
    this.stopAutoRefresh();
    this.refreshTimer = setInterval(() => {
      this.Get(this.state.page, true);
    }, AUTO_REFRESH_MS);
  };

  stopAutoRefresh = () => {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
  };

  toggleAutoRefresh = (enabled) => {
    this.setState({ auto_refresh: enabled }, () => {
      if (enabled) {
        this.startAutoRefresh();
      } else {
        this.stopAutoRefresh();
      }
    });
  };

  GetBrokers = async () => {
    let result = await GET("v1/admin/brokers/options", {
      page_size: 100000,
      page: 0,
      data_search: "",
    });
    if (result?.status) {
      this.setState({
        data_broker: [
          { value: "", label: "--Select Broker--" },
          ...result.data.map((e) => ({ value: e.uid, label: e.name_en })),
        ],
      });
    }
  };

  Get = async (page, silent = false) => {
    const {
      filter_search,
      filter_type,
      filter_result,
      filter_start_date,
      filter_end_date,
      filter_broker_id,
      filter_currency,
    } = this.state;
    if (!silent) loading(true);
    // เลือกวันเดียวใน range picker จะได้ end_date เป็น null ให้ใช้วันเดียวกับ start
    let start_date = toDateParam(filter_start_date);
    let end_date = toDateParam(filter_end_date) || start_date;
    // clear วันที่แล้วค้น: ถอยเป็น DEFAULT_RANGE_DAYS วันล่าสุด และอัปเดต picker ให้ตรงกับที่ค้นจริง
    if (!start_date) {
      start_date = daysAgo(DEFAULT_RANGE_DAYS - 1);
      end_date = today();
      this.setState({ filter_start_date: start_date, filter_end_date: end_date });
    }
    let result = await GET("v1/admin/log-webhooks", {
      page_size: PAGE_SIZE,
      page: page,
      start_date,
      end_date,
      type: filter_type,
      result: filter_result,
      data_search: filter_search,
      broker_id: filter_broker_id,
      currency: filter_currency,
    });
    if (result?.status === true) {
      this.setState({
        data: result.data,
        count: result.pagination?.count || 0,
        page,
        loaded: true,
      });
    } else {
      this.setState({ data: [], count: 0, page: 1, loaded: true });
    }
    if (!silent) loading(false);
  };

  GetByRefNo = async (ref_no, keepTab = false) => {
    loading(true);
    let result = await GET("v1/admin/log-webhooks", { ref_no });
    if (result?.status) {
      const data_detail = sortDetailRows(result.data);
      this.setState({
        data_detail,
        expand_id:
          keepTab && this.state.expand_id < data_detail.length
            ? this.state.expand_id
            : 0,
        modal_detail: true,
      });
    }
    loading(false);
  };

  resetFilter = () => {
    this.setState(
      {
        filter_search: "",
        filter_type: DEFAULT_TYPE,
        filter_result: "",
        filter_start_date: today(),
        filter_end_date: today(),
        filter_broker_id: "",
        filter_currency: DEFAULT_CURRENCY,
      },
      () => this.Get(1)
    );
  };

  resendWebhook = async () => {
    const { data_detail } = this.state;
    const transaction_uid = data_detail.find((e) => e.transaction_uid)?.transaction_uid;
    if (!transaction_uid) return;
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to resend this webhook to the broker?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      let result = await POST("callback/re-callback", { uid: transaction_uid });
      if (result?.status) {
        alert("#", "success");
        // webhook ถูกส่งแบบ async รอสักครู่ก่อนโหลดผลรอบใหม่
        setTimeout(async () => {
          await this.GetByRefNo(data_detail[0]?.ref_no, true);
          await this.Get(this.state.page, true);
        }, 1500);
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };

  copy = async (key, text) => {
    await copyText(text ?? "");
    if (this.copiedTimer) clearTimeout(this.copiedTimer);
    this.setState({ copied_key: key });
    this.copiedTimer = setTimeout(
      () => this.setState({ copied_key: "" }),
      COPIED_RESET_MS
    );
  };

  renderCopyButton = (key, text, className = "") => {
    const copied = this.state.copied_key === key;
    return (
      <span
        role="button"
        title="Copy"
        className={`pu-wh-copy-btn ${copied ? "copied" : "icon"} ${className}`}
        onClick={() => this.copy(key, text)}
      >
        {copied ? "Copied!" : "\uf0c5"}
      </span>
    );
  };

  showInlineHelpPopup = (event, popup) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const popupWidth = 330;
    const left = Math.min(
      Math.max(rect.left - 8, 16),
      window.innerWidth - popupWidth - 16
    );
    const top = Math.max(rect.top - 16, 16);
    this.setState({ inline_help_popup: { ...popup, left, top } });
  };

  hideInlineHelpPopup = () => {
    this.setState({ inline_help_popup: null });
  };

  renderDetailTabs = () => {
    const { data_detail, expand_id } = this.state;
    let attempt = 0;
    return (
      <div className="pu-wh-tabs">
        {data_detail.map((item, index) => {
          const isBank = !!item.response_body_bank;
          if (!isBank) attempt += 1;
          const label = isBank ? "From Bank" : `Attempt #${attempt}`;
          return (
            <button
              type="button"
              key={item.uid || `detail-${index}`}
              className={`pu-wh-tab ${expand_id === index ? "active" : ""} ${isBank ? "bank" : ""}`}
              onClick={() => this.setState({ expand_id: index })}
            >
              <span className="pu-wh-tab-label">
                <span className="icon me-1">{isBank ? "" : ""}</span>
                {label}
              </span>
              <span className="pu-wh-tab-time">
                {format_date(item.created_at, "dd/mm/yy hh:mm:ss")}
              </span>
              {!isBank && (
                <span className="pu-wh-tab-status">
                  {responseStatusBadge(item.response_status)}
                </span>
              )}
            </button>
          );
        })}
      </div>
    );
  };

  renderDetail = () => {
    const { data_detail, expand_id, hover_info_index } = this.state;
    const item = data_detail[expand_id];
    if (!item) return null;
    const isBank = !!item.response_body_bank;
    const bodyBankText = safeJSON(item.response_body_bank);
    const requestText = safeJSON(item.request_body);
    const responseText = safeJSON(item.response_body);

    const row = (label, value) => (
      <div className="pu-kv pu-wh-kv">
        <span className="pu-kv-label">{label}</span>
        <span className="pu-kv-value text-break">{value}</span>
      </div>
    );

    const jsonBlock = (label, key, text, extra = null) => (
      <div className="pu-wh-json">
        <div className="pu-wh-json-head">
          <span className="pu-wh-json-title">
            <span className="icon me-2">{""}</span>
            {label}
          </span>
          <span className="d-flex align-items-center">
            {extra}
            {this.renderCopyButton(key, text, "ms-2")}
          </span>
        </div>
        <pre className="pu-wh-json-body">{text || "-"}</pre>
      </div>
    );

    return (
      <div className="pu-wh-detail">
        <div className="row g-3">
          <div className={isBank ? "col-12" : "col-12 col-lg-5"}>
            <div className="pu-section h-100 mb-0">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Summary
              </div>
              {row("Date", format_date(item.created_at, "dd/mm/yyyy hh:mm:ss", "en"))}
              {row(
                "Ref No.",
                item.ref_no ? (
                  <span className="pu-code">{item.ref_no}</span>
                ) : (
                  "-"
                )
              )}
              {row(
                "Bank Ref.",
                item.reference_id ? (
                  <span className="pu-code">{item.reference_id}</span>
                ) : (
                  "-"
                )
              )}
              {row("Broker", item.broker_name || "-")}
              {row("Customer", item.customer_name || "-")}
              {row("Event Type", eventTypeBadge(item.event_type))}
              {!isBank &&
                row(
                  "URL",
                  <span className="pu-wh-url">
                    {item.webhook_url || "-"}
                    {item.webhook_url &&
                      this.renderCopyButton("url", item.webhook_url, "ms-2")}
                  </span>
                )}
              {row(
                "Response Time",
                <span className={`pu-wh-latency ${responseTimeClass(item.latency_ms)}`}>
                  {item.latency_ms || 0} ms
                </span>
              )}
              {!isBank && (
                <>
                  {row(
                    "Request Method",
                    item.request_method ? methodBadge(item.request_method) : "-"
                  )}
                  {row("Response Code", responseStatusBadge(item.response_status))}
                  {row("Response Status", deliveryStatusBadge(item.status))}
                  {row(
                    "Error Message",
                    <span className="text-danger">{item.error_message || "-"}</span>
                  )}
                </>
              )}
            </div>
          </div>
          {isBank ? (
            <div className="col-12">
              {jsonBlock(
                "Response Body Bank",
                "body_bank",
                bodyBankText,
                (item.event_type || "").includes("chillpay") && (
                  <div
                    className={`inline-help-trigger pu-wh-help ${hover_info_index ? "is-active" : ""}`}
                    onMouseEnter={(event) => {
                      this.setState({ hover_info_index: true });
                      this.showInlineHelpPopup(event, {
                        title: "PaymentStatus",
                        titleColor: "#344054",
                        lines: CHILLPAY_PAYMENT_STATUS_HELP,
                      });
                    }}
                    onMouseLeave={() => {
                      this.setState({ hover_info_index: false });
                      this.hideInlineHelpPopup();
                    }}
                  >
                    ?
                  </div>
                )
              )}
            </div>
          ) : (
            <div className="col-12 col-lg-7">
              {jsonBlock("Request Body", "request", requestText)}
              {jsonBlock("Response Body", "response", responseText)}
            </div>
          )}
        </div>
      </div>
    );
  };

  render() {
    const {
      inline_help_popup,
      modal_detail,
      filter_search,
      filter_type,
      filter_result,
      filter_start_date,
      filter_end_date,
      filter_broker_id,
      filter_currency,
      auto_refresh,
      page,
      data,
      loaded,
      count,
      data_broker,
      data_detail,
    } = this.state;
    const canResend = data_detail.some((e) => e.transaction_uid);
    const detailRef = data_detail[0]?.ref_no;
    const failedOnPage = (data || []).filter((item) =>
      isFailedDelivery(item.response_status)
    ).length;

    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />

        <div className="body p-3 mt-3">
          {/* HERO */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Monitoring</div>
                <div className="ar-title">Webhook Logs</div>
                <div className="ar-subtitle">
                  Monitor webhook activity and performance
                </div>
              </div>
              <div className="pu-tabs pu-tabs-dark mb-0">
                {TAB_TYPES.map((t) => (
                  <button
                    type="button"
                    key={t.key}
                    className={`pu-tab ${filter_type === t.key ? "active" : ""}`}
                    onClick={() =>
                      this.setState({ filter_type: t.key }, () => this.Get(1))
                    }
                  >
                    <span className="icon me-2">
                      {t.key === "deposit" ? "" : ""}
                    </span>
                    {t.label}
                  </button>
                ))}
              </div>
            </div>

            {/* FILTER */}
            <div className="ar-toolbar pu-om-filter mt-3">
              <div className="pu-om-filter-head">
                <span className="ar-toolbar-label">
                  <span className="icon me-2">{""}</span>Filter
                </span>
                <span className="ar-toolbar-hint">
                  Date range is required · max {MAX_RANGE_DAYS} days
                </span>
              </div>
              <div className="pu-om-filter-grid pu-wh-filter-grid">
                <div className="pu-om-field pu-om-field-search">
                  <span className="pu-om-field-label">Search</span>
                  <div className="pu-om-search">
                    <span className="icon pu-om-search-icon">{""}</span>
                    <input
                      type="text"
                      placeholder="Ref no. / bank ref. / customer..."
                      onChange={(e) => this.setState({ filter_search: e.target.value })}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") this.Get(1);
                      }}
                      value={filter_search}
                    />
                  </div>
                </div>
                <div className="pu-om-field pu-om-field-date">
                  <span className="pu-om-field-label">Date Range</span>
                  <DateRangePicker
                    className="form-control"
                    onChange={(e) =>
                      this.setState({
                        filter_start_date: e.start_date,
                        filter_end_date: e.end_date,
                      })
                    }
                    value={{ start_date: filter_start_date, end_date: filter_end_date }}
                    maxRangeDays={MAX_RANGE_DAYS}
                  />
                </div>
                <div className="pu-om-field">
                  <span className="pu-om-field-label">Result</span>
                  <Select
                    className="form-control"
                    placeholder="All results"
                    options={RESULT_OPTIONS}
                    onChange={(v) => this.setState({ filter_result: v })}
                    value={filter_result}
                    default={false}
                  />
                </div>
                {!this.isBrokerUser && (
                  <div className="pu-om-field">
                    <span className="pu-om-field-label">Broker</span>
                    <Select
                      className="form-control"
                      placeholder="All brokers"
                      options={data_broker}
                      onChange={(v) => this.setState({ filter_broker_id: v })}
                      value={filter_broker_id}
                      default={false}
                    />
                  </div>
                )}
                <div className="ar-toolbar-actions pu-om-filter-actions">
                  <button className="ar-btn-gold" onClick={() => this.Get(1)}>
                    <span className="icon me-2">{""}</span>Search
                  </button>
                  <button className="ar-btn-ghost" onClick={this.resetFilter}>
                    <span className="icon me-2">{""}</span>Reset
                  </button>
                </div>
              </div>
                <div className="ar-filter-foot">
                  {global.currency?.map((item) => (
                    <button
                      key={item.currency_code}
                      className={`ar-pill ${
                        item.currency_code === filter_currency ? "active" : ""
                      }`}
                      onClick={() =>
                        this.setState({ filter_currency: item.currency_code }, () =>
                          this.Get(1)
                        )
                      }
                    >
                      {item.image}
                      <span className="ms-2">{item.currency_code}</span>
                    </button>
                  ))}
                </div>
            </div>
          </div>

          {/* TABLE */}
          <div className="ar-table-card">
            <div className="ar-table-head flex-wrap gap-2">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{""}</span>
                  {TAB_TYPES.find((t) => t.key === filter_type)?.label} deliveries
                </div>
                <div className="ar-table-caption">
                  {count > 0
                    ? `Showing ${(page - 1) * PAGE_SIZE + 1}–${Math.min(
                        page * PAGE_SIZE,
                        count
                      )} of ${count}`
                    : loaded
                      ? "No results"
                      : "Loading..."}
                  {failedOnPage > 0 && (
                    <span className="ms-2">
                      &middot; <span className="pu-wh-failed-note">{failedOnPage} failed</span> on this page
                    </span>
                  )}
                </div>
              </div>
              <div className="d-flex align-items-center flex-wrap gap-2">
                <span className="ar-legend d-none d-lg-inline-flex align-items-center me-2">
                  <span className="pu-legend-swatch pu-wh-swatch-failed" />
                  Failed delivery
                </span>
                <button
                  type="button"
                  className={`pu-om-ctl ${auto_refresh ? "active" : ""}`}
                  onClick={() => this.toggleAutoRefresh(!auto_refresh)}
                  title="Auto refresh every 30 seconds"
                >
                  <span className="icon me-1">{""}</span>
                  {auto_refresh ? "Auto 30s" : "Auto"}
                </button>
                <button
                  type="button"
                  className="pu-om-ctl"
                  onClick={() => this.Get(page)}
                  title="Refresh"
                >
                  <span className="icon me-1">{""}</span>Refresh
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover ar-table pu-table">
                <thead>
                  <tr>
                    <td className="text-nowrap">Time</td>
                    <td className="text-nowrap">Broker</td>
                    <td className="text-nowrap">Customer</td>
                    <td className="text-nowrap">RefNo</td>
                    <td className="text-nowrap">Bank Ref.</td>
                    <td className="text-nowrap text-center">Type</td>
                    <td className="text-nowrap text-center">Status Code</td>
                    <td className="text-nowrap text-center" title="Success / Attempts">
                      Success / Attempts
                    </td>
                    <td className="text-nowrap text-end">Response Time</td>
                    <td className="text-nowrap text-center wpx-100">Actions</td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => {
                    const failed = isFailedDelivery(item.response_status);
                    const success = Number(item.success_count ?? 0);
                    const attempts = Number(item.attempt_count ?? 0);
                    const ratioTone =
                      attempts === 0
                        ? "off"
                        : success === 0
                          ? "off"
                          : success === attempts
                            ? "on"
                            : "part";
                    return (
                      <tr
                        key={item.ref_no || `array-${index}`}
                        className={failed ? "pu-row-failed" : ""}
                      >
                        <td data-label="Time" className="text-nowrap">
                          <span className="pu-mono">
                            {format_date(item.created_at, "dd/mm/yyyy hh:mm:ss", "en")}
                          </span>
                        </td>
                        <td data-label="Broker" className="text-nowrap">
                          <span className="pu-name">{item.broker_name || "-"}</span>
                        </td>
                        <td data-label="Customer" className="text-nowrap">
                          {item.customer_name || <span className="pu-none">-</span>}
                        </td>
                        <td data-label="RefNo" className="text-nowrap">
                          {item.ref_no ? (
                            <span className="d-inline-flex align-items-center">
                              <span className="pu-code">{item.ref_no}</span>
                              {this.renderCopyButton(`ref-${index}`, item.ref_no, "ms-2 pu-wh-copy")}
                            </span>
                          ) : (
                            <span className="pu-none">-</span>
                          )}
                        </td>
                        <td data-label="Bank Ref." className="text-nowrap">
                          {item.reference_id ? (
                            <span className="d-inline-flex align-items-center">
                              <span className="pu-code">{item.reference_id}</span>
                              {this.renderCopyButton(`bank-${index}`, item.reference_id, "ms-2 pu-wh-copy")}
                            </span>
                          ) : (
                            <span className="pu-none">-</span>
                          )}
                        </td>
                        <td data-label="Type" className="text-nowrap">
                          <div className="d-flex justify-content-center">
                            {eventTypeBadge(item.event_type)}
                          </div>
                        </td>
                        <td data-label="Status Code" className="text-nowrap">
                          <div className="d-flex justify-content-center">
                            {responseStatusBadge(item.response_status)}
                          </div>
                        </td>
                        <td data-label="Success / Attempts" className="text-nowrap text-center">
                          <span className={`pu-wh-ratio ${ratioTone}`}>
                            <b>{success}</b>
                            <span className="pu-wh-ratio-sep">/</span>
                            {attempts}
                          </span>
                        </td>
                        <td data-label="Response Time" className="text-nowrap text-end">
                          <span className={`pu-wh-latency ${responseTimeClass(item.latency_ms)}`}>
                            {item.latency_ms || 0} ms
                          </span>
                        </td>
                        <td data-label="Actions" className="text-center">
                          <Dropdown align="end">
                            <Dropdown.Toggle className="pu-action-toggle" id={`webhook-actions-${index}`}>Action</Dropdown.Toggle>
                            <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                              <Dropdown.Item className="pu-action-item" onClick={() => this.GetByRefNo(item.ref_no)}>
                                <span className="icon">{""}</span>View
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    );
                  })}
                  {loaded && data?.length === 0 && (
                    <tr>
                      <td colSpan={10}>
                        <div className="ar-empty">
                          <span className="icon me-2">{""}</span>No webhook logs in
                          this range
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-3">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / PAGE_SIZE) || 1}
              page={page}
              showFirstButton
              showLastButton
              onChange={(_, p) => this.Get(p)}
            />
          </div>
        </div>

        <Modal
          show={modal_detail}
          onHide={() => this.setState({ modal_detail: false, inline_help_popup: null })}
          size="xl"
          dialogClassName="pr-modal pr-scope pu-scope"
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div className="d-flex align-items-center flex-wrap gap-2 w-100 pe-3">
              <div>
                <div className="pr-modal-eyebrow">Webhook</div>
                <h5 className="fw-bold mb-0">
                  Detail Webhook{" "}
                  {detailRef ? <span className="pu-currency-tag">{detailRef}</span> : null}
                </h5>
              </div>
              {canResend && (
                <button
                  type="button"
                  className="pu-doc-btn gold ms-auto"
                  onClick={this.resendWebhook}
                >
                  <span className="icon me-2">{""}</span>Resend Webhook
                </button>
              )}
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body pu-om-modal-body pb-3">
            {inline_help_popup && (
              <div
                className="inline-help-popup wpx-330"
                style={{ left: inline_help_popup.left, top: inline_help_popup.top }}
              >
                <div
                  className="fw-semibold mb-1"
                  style={{ fontSize: 12, color: inline_help_popup.titleColor || "#344054" }}
                >
                  {inline_help_popup.title}
                </div>
                {inline_help_popup.lines?.map((line, idx) => (
                  <div key={`inline-help-${idx}`} className="text-14">
                    {line}
                  </div>
                ))}
              </div>
            )}
            {this.renderDetailTabs()}
            {this.renderDetail()}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
